module.exports = __webpack_public_path__ + "static/media/minus-hexagon.98e19f0d.svg";